module.exports = __webpack_public_path__ + "c217f6c5e0beb729dc60b6b4965000fc.jpg";